<div [formGroup]="frm">
  <label [ngClass]="required ? 'is-required ms-Label' : 'ms-Label'" [for]="formControlName">{{label}}</label>
  <div class="form-group">
    <div *ngIf="!readonly">
      <textarea 
        [formControlName]="formControlName" 
        [id]="formControlName" 
        class="text-Create form-control" 
        [placeholder]="label" 
        [rows]="rows" 
        (input)="onInputChange($event)" 
      ></textarea>
    </div>
    <div *ngIf="readonly">
      <textarea 
        readonly 
        [formControlName]="formControlName" 
        [id]="formControlName" 
        class="text-Create form-control" 
        [placeholder]="label" 
        [rows]="rows"
      ></textarea>
    </div>    
  </div>
  <div style="color: brown;" *ngIf="ctrlInvalid && (ctrlTouched || ctrlDirty)" class="text-danger">
    {{ ctrlRequiredError ? label + ' es obligatorio.' : label + ' no cuenta con el formato correcto.' }}
  </div>
  <div *ngIf="min || max">
    <small>
      {{currentLength}} 
      <span *ngIf="min">/ Mínimo: {{min}}</span> 
      <span *ngIf="max">/ Máximo: {{max}}</span>
    </small>
  </div>
</div>
